import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config/config";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "../Styles/NFTbox.css";
import Dashboardheader from "../directives/dashboardheader";
import Cookies from "js-cookie";
import "../component/dashboard.css";
import {
  UserPurchasedPlan,
  DashboardStatistics,
  getcmsAction,
  getboxValueAction,
  getNewCmsAction,
  getAirDropAction,
} from "../Action/user.action";
import CopyToClipboard from "react-copy-to-clipboard";
import toast, { Toaster } from "react-hot-toast";
import { RiTeamLine } from "react-icons/ri";
import NftDetailsModal from "./Modals/NftDetailsModal";
import NonEligibilityCardDetailsModal from "./Modals/NonEligibilityAirDropModal";
import AirdropModal from "./Modals/AirDropModal";
import AirdropDoneModal from "./Modals/AirdropDoneModal";

const Dashboard = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [boxData, setBoxData] = useState([]);
  const [userdata, setuserdata] = useState([]);
  const [dashboarddata, setdashboarddata] = useState({});
  const [userdatahistory, setuserdatahistory] = useState([]);
  const [userdataid, setuserdataid] = useState([]);
  const [cmsData, setCmsData] = useState();
  const [mntPrice, setMntPrice] = useState();
  const [showAirDropModel, setShowAirDropModel] = useState(false);
  const [showAirDropDoneModel, setShowAirDropDoneModel] = useState(false);
  const [airdropModalData, setAirdropModalData] = useState([]);
  const [showNonEligibilityAirDropModal, setShowNonEligibilityAirDropModal] =
    useState(false);

  const [termsandconditionlist, settermsandconditionlist] = useState({
    freeSignUpterms: "",
  });
  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
        Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
      );

  useEffect(() => {
    getCardData();
    UsersPlan();
    getTermsAndConditionFunc();
    dynamicCms();
    getboxValue();
    setTimeout(() => {}, 1000);
    dynamicLink();
  }, []);

  const dynamicLink = () => {
    let url = window.location.href;
    const hashIndex = url.indexOf("#");
    if (hashIndex !== -1) {
      let hash = url?.slice(hashIndex + 1);
      if (hash === "subscribedplan") {
        let targetElement = document.getElementById("subscribedplan");
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    } else {
      return;
    }
  };

  const copieBtn = async () => {
    toast.success(`Copied!!`);
  };

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setuserdataid(data);
    setTimeout(() => {
      setShow(true);
    }, 500);
  };

  const handleNftDeatils = () => {
    if (mntPrice == 0) {
      navigate(`${config.baseUrl}nftbox`);
      return;
    } else {
      navigate(`${config.baseUrl}nftboxdetails`);
    }
  };

  const UsersPlan = async () => {
    let res2 = await DashboardStatistics();
    if (res2.success) {
      setdashboarddata(res2.data);
    } else {
      setdashboarddata([]);
    }

    let res1 = await UserPurchasedPlan();
    if (res1.success) {
      if (res1.data == null) {
        setuserdata([]);
        setuserdatahistory([]);
      } else {
        setuserdata(res1.data.myplan);
        setuserdatahistory(res1.data.history);
      }
    } else {
      setuserdata([]);
      setuserdatahistory([]);
    }
  };

  const getExpireDay = (expiryDate) => {
    return Math.ceil(
      (new Date(expiryDate) - new Date()) / (1000 * 60 * 60 * 24)
    );
  };

  const isMintFunc = (data) => {
    window.location.href = `${config.baseUrl}mintnft/${data}`;
  };
  const dynamicCms = async () => {
    try {
      let res = await getcmsAction("freesignupterms");
      if (res.success) {
        setCmsData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getboxValue = async () => {
    try {
      const res = await getboxValueAction();
      if (res.success) {
        setMntPrice(res.data.nft_box_value);
        setBoxData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTermsAndConditionFunc = async () => {
    let res = await getNewCmsAction("freeSignUp-tc");
    if (res.success && res.data?.cms_value) {
      settermsandconditionlist({ freeSignUpterms: res.data.cms_value });
    } else {
      console.error("Failed to fetch CMS content");
    }
  };

  // const getCardData = async () => {
  //   try {
  //     const res = await getAirDropAction();
  //     console.log(res.data.length)
  //     if (res.data[0].length > 0) {
  //       setAirdropModalData(res?.data);
  //       const data = res?.data;
  //       localStorage.setItem("is_popup_active", JSON.stringify(data[0].is_popup_active));

  //       if (data[0].is_popup_active) {
  //         if (data === null || data.length === 0) {
  //           setShowAirDropModel(false);
  //           setShowNonEligibilityAirDropModal(true);
  //           return;
  //         }
  //         var user = data[0];
  //         if (user.airdrop_remaining) {
  //           setShowAirDropModel(true);
  //           setShowNonEligibilityAirDropModal(false);
  //         } else {
  //           setShowAirDropModel(false);
  //           setShowNonEligibilityAirDropModal(false);
  //         }
  //       }
  //       if (user?.airdrop_done && !user?.read_status) {
  //         setShowAirDropDoneModel(true);
  //       } else {
  //         setShowAirDropDoneModel(false);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching airdrop data:", error);
  //     setShowAirDropDoneModel(false);
  //     setShowAirDropModel(false);
  //     setShowNonEligibilityAirDropModal(false);
  //     localStorage.removeItem("is_popup_active");

  //   }
  // };
  const getCardData = async () => {
    try {
      const res = await getAirDropAction();

      const data = Array.isArray(res?.data) ? res.data : [];

      if (data.length === 0) {
        // agar data empty hai
        console.warn("No airdrop data found:", res?.msg || "Data not found");

        setShowAirDropModel(false);
        setShowAirDropDoneModel(false);
        setShowNonEligibilityAirDropModal(false);
        localStorage.removeItem("is_popup_active");
        return;
      }

      setAirdropModalData(data);
      localStorage.setItem(
        "is_popup_active",
        JSON.stringify(data[0]?.is_popup_active)
      );

      const user = data[0];

      if (user?.is_popup_active) {
        if (user?.airdrop_remaining) {
          setShowAirDropModel(true);
          setShowNonEligibilityAirDropModal(false);
        } else {
          setShowAirDropModel(false);
          setShowNonEligibilityAirDropModal(false);
        }
      } else {
        setShowAirDropModel(false);
        setShowNonEligibilityAirDropModal(false);
      }

      if (user?.airdrop_done && !user?.read_status) {
        setShowAirDropDoneModel(true);
      } else {
        setShowAirDropDoneModel(false);
      }
    } catch (error) {
      console.error("Error fetching airdrop data:", error);
      setShowAirDropDoneModel(false);
      setShowAirDropModel(false);
      setShowNonEligibilityAirDropModal(false);
      localStorage.removeItem("is_popup_active");
    }
  };

  return (
    <>
      <Dashboardheader />
      <Toaster />
      <div className="position-relative">
        <div className="db1"></div>

        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        <div className="page-wrapper">
          <div className="position-relative overflow-hidden mb-5">
            {/* <div className="mb-4 sm-data-box">
              <Container className="">
                <Row
                  className="justify-content-center  mt-3"
                  style={{ scrollbarWidth: "none" }}
                >
                  <Col lg={4} md={4} className="mt-4 mb-3">
                    <div className="card card-view">
                      <div className="card-body">
                        <Row>
                          <Col lg={12} xs={12}>
                            <div className="circle-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 29 26"
                                fill="none"
                              >
                                <path
                                  d="M14.3333 17.6667H8.33334C6.47258 17.6667 5.5422 17.6667 4.78514 17.8963C3.08061 18.4134 1.74672 19.7473 1.22965 21.4518C1 22.2089 1 23.1392 1 25M23.6667 25V17M19.6667 21H27.6667M17.6667 7C17.6667 10.3137 14.9804 13 11.6667 13C8.35296 13 5.66667 10.3137 5.66667 7C5.66667 3.68629 8.35296 1 11.6667 1C14.9804 1 17.6667 3.68629 17.6667 7Z"
                                  stroke="#F4F4F4"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </Col>
                          <Col lg={12} xs={12} className="text-center">
                            <div className="card-d">
                              <h3 className="sofia-sans">
                                {Number(
                                  dashboarddata.referralAmount || 0
                                ).toFixed(2)}
                              </h3>
                              <p className="mb-0 py-2 px-3 sofia-sans">
                                Referral Rewards
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={4} className="mt-4 mb-3">
                    <div className="card card-view">
                      <div className="card-body">
                        <Row>
                          <Col lg={12} xs={12}>
                            <div className="circle-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="22"
                                viewBox="0 0 24 22"
                                fill="none"
                              >
                                <path
                                  d="M13.1111 3.22222C13.1111 4.44952 10.3751 5.44444 7.00003 5.44444C3.62495 5.44444 0.888916 4.44952 0.888916 3.22222M13.1111 3.22222C13.1111 1.99492 10.3751 1 7.00003 1C3.62495 1 0.888916 1.99492 0.888916 3.22222M13.1111 3.22222V8.17461C11.7539 8.5822 10.8889 9.19881 10.8889 9.88889M0.888916 3.22222V16.5556C0.888916 17.7829 3.62495 18.7778 7.00003 18.7778C8.47739 18.7778 9.83232 18.5871 10.8889 18.2698V9.88889M0.888916 7.66667C0.888916 8.89397 3.62495 9.88889 7.00003 9.88889C8.47739 9.88889 9.83232 9.69826 10.8889 9.38094M0.888916 12.1111C0.888916 13.3384 3.62495 14.3333 7.00003 14.3333C8.47739 14.3333 9.83232 14.1427 10.8889 13.8254M23.1111 9.88889C23.1111 11.1162 20.3751 12.1111 17 12.1111C13.625 12.1111 10.8889 11.1162 10.8889 9.88889M23.1111 9.88889C23.1111 8.66159 20.3751 7.66667 17 7.66667C13.625 7.66667 10.8889 8.66159 10.8889 9.88889M23.1111 9.88889V18.7778C23.1111 20.0051 20.3751 21 17 21C13.625 21 10.8889 20.0051 10.8889 18.7778V9.88889M23.1111 14.3333C23.1111 15.5606 20.3751 16.5556 17 16.5556C13.625 16.5556 10.8889 15.5606 10.8889 14.3333"
                                  stroke="#F4F4F4"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </Col>
                          <Col lg={12} xs={12} className="text-center">
                            <div className="card-d">
                              <h3 className="sofia-sans">
                                {Number(
                                  dashboarddata.matchingAmount || 0
                                ).toFixed(2)} 
                              </h3>

                              <p className="mb-0 py-2 sofia-sans">
                                Community Rewards
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  {
                    <Col lg={4} md={4} className="mt-4 mb-3">
                      <div className="card card-view">
                        <div className="card-body">
                          <Row>
                            <Col lg={12} xs={12}>
                              <div className="circle-icon">
                                <span className="fs-5">
                                  <RiTeamLine />
                                </span>
                              </div>
                            </Col>
                            <Col lg={12} xs={12} className="text-center">
                              <div className="card-d">
                                <h3 className="sofia-sans">
                                  {dashboarddata.business_validity || "NA"}
                                </h3>

                                <p className="mb-0 py-2 sofia-sans">
                                  Business Validity
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  }
                </Row>
              </Container>
            </div> */}

            <Container>
              {/* <div>
                <h2
                  className="text-white sofia-sans"
                  style={{ fontWeight: 600 }}
                >
                  NFT Box
                </h2>
              </div> */}
              <br />
              <div className="nftbox-card d-flex flex-column justify-content-center text-white px-4 pt-4 py-3">
                <Row>
                  <Col>
                    <h3 style={{ fontWeight: 700 }} className="sofia-sans">
                      NFT Box
                    </h3>
                    <p className="mb-1 sofia-sans">Total Subscription</p>
                    <h5 className="sofia-sans" style={{ fontWeight: 600 }}>
                      {boxData?.nft_box_value_mnt} <br/>
                      {boxData?.nft_box_value_anant}
                    </h5>

                  </Col>
                  <Col className="text-end mt-1">
                    <button
                      onClick={handleNftDeatils}
                      style={{
                        border: "1px solid white",
                        borderRadius: 5,
                        textDecoration: "none",
                        color: "white",
                        fontSize: 12,
                        backgroundColor: "transparent",
                      }}
                      className="px-3 py-2 sofia-sans"
                    >
                      View Details
                    </button>
                  </Col>
                </Row>
                {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
                <div className="w-100 d-flex flex-row justify-content-center gap-4">
                  <img src="assets/images/nftbox2.svg" alt="" />
                  <img
                    className="glow-img"
                    src="assets/images/nftbox1.svg"
                    alt=""
                  />
                  <img src="assets/images/nftbox2.svg" alt="" />
                </div>
              </div>
            </Container>
            <br />
            {/* -------------------- */}

            {userdata.length && (
              <div className="ActivePlane mb-5">
                <Container className=" package_detail">
                  <Row className="justify-content-center justify-content-sm-start">
                    <Col lg={12} className="mb-3">
                      <div className="d-flex flex-row flex-wrap align-items-center justify-content-between">
                        <div>
                          <h2
                            className="text-white sofia-sans"
                            style={{ fontWeight: 600 }}
                          >
                            Subscribed Plan
                          </h2>
                        </div>
                        <div></div>
                      </div>
                    </Col>
                    {/* {userdatahistory.length == 0 ? ( */}
                    <>
                      {userdata.length == 0 ? (
                        <>
                          <center>
                            <img
                              style={{
                                width: "auto",
                                height: "auto",
                              }}
                              src="assets\images\newdesign\nodata-new.png"
                            />
                            <h4
                              className="sofia-sans"
                              style={{ color: "#d3d3d3" }}
                            >
                              You haven't purchased any plan yet.
                            </h4>
                          </center>
                        </>
                      ) : (
                        <>
                          <Row>
                            <Col>
                              <Row className=" m-0 gy-2">
                                {userdata.map((item, index) => (
                                  <>
                                    {" "}
                                    <Col
                                      lg={4}
                                      className=""
                                      style={{ display: "flex" }}
                                    >
                                      <div className="card nftplan flex-fill position-realtive ">
                                        <div className="card-body p-3  d-flex justify-content-between flex-column">
                                          {item.is_renewed ? (
                                            <>
                                              <div
                                                className="btn-sm mh-auto position-absolute renewed px-4 sofia-sans"
                                                style={{
                                                  borderRadius:
                                                    "0px 25px 0px 25px",
                                                  top: 0,
                                                  right: 0,
                                                }}
                                              >
                                                Renewed
                                              </div>
                                            </>
                                          ) : item.isexpired ? (
                                            <>
                                              <div
                                                className="btn-sm mh-auto position-absolute expired-time px-4 py-1 sofia-sans"
                                                style={{
                                                  borderRadius:
                                                    "0px 25px 0px 25px",
                                                  top: 0,
                                                  right: 0,
                                                }}
                                              >
                                                Package Expired
                                              </div>
                                            </>
                                          ) : (
                                            <div
                                              className="btn-sm mh-auto position-absolute  px-4 py-1"
                                              style={{
                                                borderRadius:
                                                  "0px 25px 0px 25px",
                                                top: 0,
                                                right: 0,
                                              }}
                                            >
                                              {getExpireDay(item.expiryDate) ===
                                              0 ? (
                                                <div
                                                  className="btn-sm mh-auto position-absolute expired-time sofia-sans  px-4 py-1"
                                                  style={{
                                                    borderRadius:
                                                      "0px 18px 0px 25px",
                                                    width: "max-content",
                                                    top: 0,
                                                    right: 0,
                                                  }}
                                                >
                                                  Expire Today{" "}
                                                </div>
                                              ) : item.near_expiry ? (
                                                <div
                                                  className="btn-sm mh-auto position-absolute expired-time sofia-sans  px-4 py-1"
                                                  style={{
                                                    borderRadius:
                                                      "0px 18px 0px 25px",
                                                    width: "max-content",
                                                    top: 0,
                                                    right: 0,
                                                  }}
                                                >
                                                  Expire In{" "}
                                                  {getExpireDay(
                                                    item.expiryDate
                                                  )}{" "}
                                                  Days{" "}
                                                </div>
                                              ) : (
                                                <>
                                                  <div
                                                    className=" mh-auto position-absolute sofia-sans  px-4 py-1"
                                                    style={{
                                                      borderRadius:
                                                        "0px 18px 0px 25px",
                                                      top: 0,
                                                      right: 0,
                                                      backgroundColor: "green",
                                                    }}
                                                  >
                                                    Subscribed
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          )}

                                          <div className=" pb-1 px-2">
                                            <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center  mt-4 mb-3">
                                              <h6 className="mb-0 text-white sofia-sans">
                                                {item.name}
                                              </h6>
                                              {!item.free_signup && (
                                                <div>
                                                  <p
                                                    style={{ fontSize: 12 }}
                                                    className="mb-0 px-3 py-1 w-auto h-100 sofia-sans"
                                                  >
                                                     {item.priceMNT} MNT 
                                                  </p>
                                                </div>
                                              )}
                                            </div>

                                            <div className="d-flex gap-2 justify-content-between align-items-center mb-3 mt-2">
                                              <div className="pla ">
                                                <p
                                                  className="text-wrap px-3 mb-0 py-1 sofia-sans"
                                                  style={{ fontSize: 12 }}
                                                >
                                                  Valid till :{" "}
                                                  <span
                                                    className="text-nowrap sofia-sans"
                                                    style={{ fontSize: 12 }}
                                                  >
                                                    {item.expiryDate}
                                                  </span>
                                                </p>
                                              </div>
                                              <div>
                                                <div
                                                  onClick={() =>
                                                    handleShow(item.uniqueId)
                                                  }
                                                  className="rounded-1 mh-auto px-2 px-sm-4 py-1 main5 text-center sofia-sans"
                                                  style={{
                                                    fontSize: 12,
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  View Details
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="card-view text-center p-4 rounded-30 position-relative">
                                            <img
                                              src={`${
                                                config.ipfsurl + item.image
                                              }`}
                                              alt={item.image}
                                              style={{
                                                width: 100,
                                                height: 100,
                                              }}
                                              className="img-fluid"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    {item.free_signup && (
                                      <Col lg={6} className="pt-3">
                                        <h5 className="text-danger sofia-sans">
                                          Note:
                                        </h5>
                                        <p className="sofia-sans">
                                          WhatsApp verification is essential for
                                          free signup users to avail their step
                                          rewards. You can verify your whatsapp
                                          mobile number in the profile section.{" "}
                                        </p>
                                      </Col>
                                    )}
                                  </>
                                ))}
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  </Row>
                </Container>
              </div>
            )}

            {userdatahistory.length !== 0 && (
              <div className="latest_transaction mb-5">
                <Container className="">
                  <Row>
                    <Col lg={12} className="mb-3">
                      <h2
                        className="text-white sofia-sans"
                        style={{ fontWeight: 600 }}
                      >
                        Latest Transactions
                      </h2>
                    </Col>

                    <Col lg={12}>
                      <div className="card card-view">
                        <div className="card-body p-4">
                          <div className="">
                            <div className="table_list">
                              <div className="table-responsive">
                                <table
                                  width="100%"
                                  className="text-center sofia-sans"
                                >
                                  <thead
                                    style={{
                                      border:
                                        "1px solid rgba(167, 167, 167, 0.15)",
                                    }}
                                  >
                                    <tr>
                                      <th>Package Name</th>
                                      {/* <th>Price</th> */}
                                      <th>Price</th>
                                      <th>Credit Used</th>
                                      <th>Valid Till </th>
                                      <th>Subscribed On (GMT)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {userdatahistory.length == 0 ? (
                                      <tr className="tr_list">
                                        <td colSpan="5">No Data Available</td>
                                      </tr>
                                    ) : (
                                      userdatahistory.map((item, index) => (
                                        <tr className="tr_list px-2">
                                          <td className="px-4">{item.name}</td>
                                          {/* <td className="px-4">
                                            {item.priceUSD} 
                                          </td> */}
                                          <td className="px-4">
                                            {item.priceMNT} {item.coinname}
                                          </td>
                                          <td className="px-4">
                                            {item.credit_used} {item.coinname}
                                          </td>
                                          <td className="px-4">
                                            {item.datetime}
                                          </td>
                                          <td className="px-4">
                                            {item.activationdate}
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            )}
            {/* -------------------- */}
            <div className="adv-banner mb-5 mt-2">
              <Container className="">
                <Row>
                  <Col lg={12}>
                    <div className="card card-view overflow-hidden">
                      <div className=" ">
                        <Row className="align-items-center justify-content-center my-5">
                          <Col lg={6} className="text-center">
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin1"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin2"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin3"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin4"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin5"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin6"
                            />

                            <div>
                              <h3 className="mb-3 sofia-sans">Referral Link</h3>
                              <Form.Group
                                controlId="formBasicEmail"
                                className="d-flex align-items-center position-relative px-3"
                              >
                                <Form.Control
                                  type="text"
                                  value={
                                    config.refLink + loginData?.referral_code
                                  }
                                  className="mr-3 custom_field sofia-sans"
                                />
                                <CopyToClipboard
                                  text={
                                    config.refLink + loginData?.referral_code
                                  }
                                >
                                  <Button
                                    onClick={copieBtn}
                                    variant="btn btn-main2 me-3"
                                  >
                                    <span
                                      title="Click to Copy"
                                      className="mr-copylink"
                                      id="token-buy-button"
                                      style={{
                                        cursor: "pointer",
                                        color: "#FFF",
                                      }}
                                    >
                                      <i className="fa fa-clone "></i>
                                    </span>
                                  </Button>
                                </CopyToClipboard>
                                {/* <div className="random-bn"></div> */}
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
        <AirdropModal
          show={showAirDropModel}
          handleClose={() => setShowAirDropModel(!showAirDropModel)}
        />
        {showAirDropDoneModel && (
          <AirdropDoneModal
            show={showAirDropDoneModel}
            data={airdropModalData}
            handleClose={() => setShowAirDropDoneModel(!showAirDropDoneModel)}
          />
        )}
        <NonEligibilityCardDetailsModal
          show={showNonEligibilityAirDropModal}
          handleClose={() => setShowNonEligibilityAirDropModal(false)}
        />
        {show && (
          <NftDetailsModal
            show={show}
            handleClose={handleClose}
            userdata={userdata}
            userdataid={userdataid}
            getExpireDay={getExpireDay}
            isMintFunc={isMintFunc}
            cmsData={cmsData}
            termsandconditionlist={termsandconditionlist}
            copieBtn={copieBtn}
          />
        )}
      </div>
    </>
  );
};
export default Dashboard;
